import React, { useContext, useEffect, useState } from "react";
import {
  Box,
  Button,
  Heading,
  Card,
  CardBody,
  CardFooter,
  Layer,
  Text,
  Grid,
  Spinner,
} from "grommet";
import { HeaderNavigation } from "../components/Headers/GlobalHeader";
import { Notification } from "grommet-icons";
import { StickyFooter } from "../components/Footers/GlobalFooter";
import { AuthContext } from "../contexts/AuthContext";
import { useLocation, useNavigate, useParams } from "react-router-dom";

import { DigitalLearningCourses } from "../components/LearningPaths/DigitalLearningCourses";

import {
  getUserName,
  checkQuizStatus,
  getRecommendedPaths,
} from "../services/dashboardService";
import axios from "axios";
import API_URL from "../config/config";
import AssessmentCard from "../components/ManagerPortal/AssessmentCard";
const Dashboard = () => {
  const location = useLocation();
  const { user_id } = useParams();
  const navigate = useNavigate();
  const { user } = useContext(AuthContext);
  const [userName, setUserName] = useState(
    localStorage.getItem("userName") ? localStorage.getItem("userName") : "",
  );
  const [recommendedPaths, setRecommendedPaths] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [showAllProducts, setShowAllProducts] = useState(false); // State for toggling all products
  const [showButton, setShowButton] = useState(false);
  // const [showModal, setShowModal] = useState(false);
  const [assessmentResult, setAssessmentResult] = useState([]);
  const [loading, setLoading] = useState(true);
  const [showAllAssessments, setShowAllAssessments] = useState(false);
  const [skillsData, setSkillsData] = useState([]);

  const assessment_id = location.state?.assessment_id;
  const [popup, setPopup] = useState({
    message: "",
    status: "",
    visible: false,
  });

  const toggleAllAssessmentsVisibility = () => {
    setShowAllAssessments((prev) => !prev);
  };

  useEffect(() => {
    console.log("assessment_id", assessment_id);
    const fetchData = async () => {
      try {
        const [name, quizStarted, courses] = await Promise.all([
          getUserName(user_id),
          checkQuizStatus(user_id),
          getRecommendedPaths({ user_id, assessment_id }),
        ]);
        if (userName === "") {
          setUserName(name);
        }
        setRecommendedPaths(courses);
        setShowButton(quizStarted);
      } catch (error) {
        console.error("Error loading dashboard data:", error);
      } finally {
        setIsLoading(false);
      }
    };
    fetchData();

    const fetchAssessmentData = async () => {
      try {
        const result = await axios.get(
          `${API_URL}/dashboard/checkquiz/${user_id}`,
        );
        if (result.data.assessmentResult) {
          setAssessmentResult(result.data.assessmentResult.reverse());
        }
        console.log("Assessment data:", result.data.assessmentResult);
        setLoading(false);
      } catch (error) {
        console.error("Error fetching assessment data:", error);
      }
    };
    fetchAssessmentData();

    const fetchSkillsData = async () => {
      const result = await axios.get(`${API_URL}/user/getRolesAndSkills`);
      setSkillsData(result.data.sub_product_skills);
    };
    fetchSkillsData();
  }, [user_id]);

  const toggleAllCoursesVisibility = () => {
    setShowAllProducts((prevState) => !prevState);
  };

  const handleViewCourses = (path) => {
    navigate(`/${user_id}/learning-path/${path.learningpath_id}`, {
      state: { path },
    });
  };

  const handleRetake = () => {
    navigate(`/add-proficiency/${user_id}`);
  };

  const handleEnroll = (course) => {
    if (course.c_id === "H45ZDS") {
      window.open(
        `https://www.hpe.com/us/en/collaterals/collateral.a50013061enw.html`,
        "_blank",
      );
    } else if (course.c_id === "H45ZCS") {
      window.open(
        `https://www.hpe.com/us/en/collaterals/collateral.a50013273enw.html`,
        "_blank",
      );
    } else if (course.OEM === "morpheus") {
      window.open(
        `https://education.hpe.com/ww/en/training/contactus.html`,
        "_blank",
      );
    } else {
      window.open(
        `https://education.hpe.com/ww/en/training/docs/cds/${course.c_id}.pdf`,
        "_blank",
      );
    }
  };
  const handleelearningEnroll = (course) => {
    const course_code_map = {
      "HPE OneView for Compute": "H62E2AAE",
      "HPE OneView for HPE ProLiant DL/ML Servers": "H9TR9AAE",
      "HPE Synergy Administration with HPE OneView": "H0LP7AAE",
      "HPE SimpliVity System Administration": "H9TS2AAE",
    };
    const modifiedCourseId = course_code_map[course.name];

    window.open(
      `https://education.hpe.com/ww/en/training/docs/cds/${modifiedCourseId}.pdf`,
      "_blank",
    );
  };

  // Slice the courses to show only the first 3, and toggle to show all
  const displayedCourses = showAllProducts
    ? recommendedPaths
    : recommendedPaths.slice(0, 3);
  console.log("displayedCourses", displayedCourses);

  const getTopicName = (topicId) => {
    const skill = skillsData.find((skill) => skill.id === topicId);
    return skill ? `${skill.product_name} - ${skill.skill_name}` : null;
  };

  return (
    <Box fill="vertical" justify="between">
      <Box flex="grow">
        <HeaderNavigation />
        <Box pad="medium" direction="row" justify="between" align="center">
          <Heading level="1">
            {userName === "unknown" ||
              userName === "NULL" ||
              userName === "" ||
              userName === null
              ? `Hi!`
              : `Hi ${userName}!`}
          </Heading>

          <Box direction="row" gap="small">
            {/* <Button label="Support" onClick={() => {
              window.location.href = "mailto: hpe.skilladvisor@meteoros.in?subject=Support%20Request%20-%20Issue%20with%20[Feature/Product]&body=Dear%20Support%20Team,%0D%0A%0D%0AI%20am%20reporting%20an%20issue%20with%20[Feature/Product].%0D%0A%0D%0AName:%20[Your%20Name]%0D%0AEmail:%20[Your%20Email]%0D%0AIssue%20Summary:%20[Brief%20description]%0D%0ADetailed%20Description:%0D%0A[Provide%20more%20details]%0D%0A%0D%0APriority%20Level:%20[Low%20|%20Medium%20|%20High%20|%20Critical]%0D%0AAttachments:%20[Attach%20files%20manually]%0D%0A%0D%0AThank%20you,%0D%0A[Your%20Name]%0D%0A[Your%20Contact%20Information]";
            }} 
            primary/> */}
            <Button
              label="Your skills summary"
              primary
              onClick={() => {
                navigate(`/quiz-results/${user_id}`);
              }}
            />

            {showButton ? (
              <Button
                icon={<Notification color={"status-critical"} />} // Add alert icon to notify
                label="New assessments available!"
                primary
                onClick={() => {
                  navigate(`/user/user-assessments/${user_id}`); // Redirect on click
                }}
              />
            ) : (
              <Button
                label="Retake assessment"
                primary
                onClick={handleRetake}
              />
            )}
          </Box>
        </Box>
        <Box
          border={{ color: "brand", size: "xsmall" }}
          width="75%"
          alignSelf="end"
        />
        <Box pad="small" align="start" margin={{ bottom: "medium" }}>
          {assessmentResult.length > 0 ? (
            <>
              <Heading level="1" margin={{ top: "small", left: "small" }}>
                Assessments available ({assessmentResult.length} total)
              </Heading>

              <Box
                pad="small"
                direction="row"
                gap="medium"
                wrap
                margin={{ bottom: "medium", top: "small", horizontal: "small" }}
              >
                {assessmentResult
                  .sort((a, b) => new Date(a.due_by) - new Date(b.due_by))
                  .slice(0, showAllAssessments ? assessmentResult.length : 3)
                  .map((assessment) => (
                    <AssessmentCard
                      key={assessment.assesment_id}
                      assessment={assessment}
                      getTopicName={getTopicName}
                      user_id={user_id}
                      assessment_id={assessment.assesment_id}
                      manager_id={assessment.manager_id}
                    />
                  ))}
              </Box>

              {assessmentResult.length > 3 && (
                <Box
                  align="center"
                  margin={{ top: "medium" }}
                  alignSelf="center"
                >
                  <Button
                    color="brand"
                    label={
                      showAllAssessments
                        ? "Show less assessments"
                        : "Show more assessments"
                    }
                    onClick={toggleAllAssessmentsVisibility}
                  />
                </Box>
              )}
            </>
          ) : null}

          <Heading level="1" margin={{ top: "small", left: "small" }}>
            Recommended courses ({recommendedPaths.length} total)
          </Heading>

          {isLoading ? (
            <Box align="center" pad="medium">
              <Spinner size="medium" />
              <Text>Loading recommended courses...</Text>
            </Box>
          ) : recommendedPaths.length > 0 ? (
            <>
              <Box pad="small" margin={{ bottom: "medium" }}>
                <Grid
                  columns={{ count: 3, size: "auto" }} // Ensure 3 cards per row
                  gap="medium" // Adjust gap between cards to make them look less congested
                  pad={{ horizontal: "small", vertical: "small" }}
                >
                  {displayedCourses.map((course) => (
                    <Card
                      key={course.id}
                      background="light-1"
                      pad="small"
                      margin="small"
                      elevation="small"
                      round="small"
                      style={{
                        border: "1px solid #E0E0E0",
                        minWidth: "300px",
                        maxWidth: "350px",
                        minHeight: "250px",
                      }}
                    >
                      <CardBody pad="small">
                        <Box fill="vertical" justify="between" gap="small">
                          <Heading
                            level="3"
                            margin={{ top: "none", bottom: "small" }}
                            style={{ minHeight: "40px", color: "#333" }}
                          >
                            {course.name}
                          </Heading>
                          <Box gap="xsmall">
                            <Text size="small" color="dark-4">
                              Duration: <strong>{course.duration}</strong>
                            </Text>
                            <Text size="small" color="dark-4">
                              {course.isElearning === 2
                                ? "eLearning/ILT/VILT"
                                : course.isElearning
                                  ? "eLearning"
                                  : "ILT/VILT"}
                            </Text>
                          </Box>
                        </Box>
                      </CardBody>

                      <CardFooter
                        pad={{ horizontal: "small", vertical: "small" }}
                        background="light-2"
                        round={{ corner: "bottom", size: "small" }}
                        style={{ borderTop: "1px solid #E0E0E0" }}
                        direction="column"
                      >
                        {/* First Row: Course Outline and eLearning Outline */}
                        <Box
                          direction="row"
                          gap="small"
                          fill="horizontal"
                          justify="center"
                        >
                          {course.c_id === "H45ZMAAE" || course.c_id === "H45YZS" || course.c_id === "H45YYS" ? (
                            <Button
                              label="Contact us to enroll"
                              onClick={() => handleEnroll(course)}
                              primary
                              size="small"
                              style={{ minWidth: "120px" }}
                            />
                          ) : (
                            <Button
                              label="View course data sheet"
                              onClick={() => handleEnroll(course)}
                              primary
                              size="small"
                              style={{ minWidth: "120px" }}
                            />
                          )}
                          {course.isElearning === 2 && (
                            <Button
                              label="View eLearning data sheet"
                              onClick={() => handleelearningEnroll(course)}
                              secondary
                              size="small"
                              style={{ minWidth: "120px" }}
                            />
                          )}
                        </Box>

                        {/* Second Row: Learning Path */}
                        <Box fill="horizontal" justify="center">
                          <Button
                            label="View learning path"
                            onClick={() => handleViewCourses(course)}
                            secondary
                            size="small"
                            style={{ minWidth: "120px" }}
                          />
                        </Box>
                      </CardFooter>
                    </Card>
                  ))}
                </Grid>
              </Box>

              {recommendedPaths.length > 3 ? (
                <Box
                  align="center"
                  margin={{ top: "medium" }}
                  alignSelf="center"
                  alignContent="center"
                >
                  <Button
                    color="brand"
                    label={
                      showAllProducts
                        ? "Show less courses"
                        : "Show more courses"
                    }
                    onClick={toggleAllCoursesVisibility}
                  />
                </Box>
              ) : null}

              {popup.visible && (
                <Layer
                  onEsc={() => setPopup({ ...popup, visible: false })}
                  onClickOutside={() => setPopup({ ...popup, visible: false })}
                >
                  <Box pad="medium" gap="small" width="medium">
                    <Heading level={3} margin="none">
                      {popup.status === "normal" ? "Success" : "Error"}
                    </Heading>
                    <Text>{popup.message}</Text>
                    <Box direction="row" gap="medium" justify="end">
                      <Button
                        label="Close"
                        onClick={() => setPopup({ ...popup, visible: false })}
                        primary
                      />
                    </Box>
                  </Box>
                </Layer>
              )}
            </>
          ) : (
            <Text margin={{ top: "small", left: "small" }}>
              Based on the skills that you have selected and your responses,
              there are currently no recommended courses. You can try a new
              self-assessment with a new set of skills.
            </Text>
          )}
        </Box>
        <Box
          border={{ color: "brand", size: "xsmall" }}
          width="75%"
          alignSelf="end"
        />
        <DigitalLearningCourses
          user_id={user_id}
          assessment_id={assessment_id}
        />
      </Box>
      <StickyFooter />
    </Box>
  );
};
export default Dashboard;
